import ApiClient from './apiClient'
import { CustomSummaryRequest, CustomSummaryResponse, DailySummaryRequest, DailySummaryResponse } from '../types/dataSummary'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailySummary = async (params: DailySummaryRequest): Promise<any> => ApiClient.get(
  '/api/summary/daily/member',
  (result: DailySummaryResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomSummary = async (params: CustomSummaryRequest): Promise<any> => ApiClient.get(
  '/api/summary/custom/member',
  (result: CustomSummaryResponse) => result,
  params,
)
